// Shared by the store, Mythic+ and Build Insights: all three used to carry their own copy of
// this, and a season that is active in one of them has to be the same season in the others.
export function pickDefaultSeason(seasons = []) {
  const seasonOptions = seasons
    .filter((season) => season.is_main_season)
    .sort((left, right) => new Date(right.starts?.us || 0) - new Date(left.starts?.us || 0))
  const now = Date.now()
  const activeSeason = seasonOptions.find((season) => {
    const start = new Date(season.starts?.us || season.starts?.eu || 0).getTime()
    const end = new Date(season.ends?.us || season.ends?.eu || 0).getTime()
    return start <= now && now <= end
  })

  return activeSeason || seasonOptions[0] || null
}
